import { useEffect } from "react";

//redux
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { routes } from "../routes";

//utilities/constants
import { pathNames } from "../utilities/constants";

//slice
import { hideOffCanvas, setIsOffCanvasOpen, setIsOffCanvasThreeOpen } from "../commonSlice";

//styles
import "./custom-components.style.scss";

import PropTypes from "prop-types";

const BreadCrumb = ({ path, nonLink }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setIsOffCanvasOpen({ isDrilldownOpen: false }));
    dispatch(setIsOffCanvasThreeOpen({ hideOffCanvasThree: false }));
    dispatch(hideOffCanvas(false));
  }, [path]);

  const getPathName = (name) => {
    if (pathNames[name] !== undefined) {
      return pathNames[name];
    }
    try {
      return decodeURIComponent(name).replaceAll("/", " ");
    } catch {
      return name;
    }
  };

  const findRouteUrl = (routeObj, targetPath) => {
    if (!routeObj) return "";
    if (!routeObj.childNavs) {
      return routeObj.path === targetPath ? targetPath : "";
    }
    for (const childNav of routeObj.childNavs) {
      const found = findRouteUrl(childNav, targetPath);
      if (found) return found;
    }
    return "";
  };

  if (!path) return null;

  const pathArray = path.split("/").filter((p) => p.length > 0);

  if (pathArray.length === 0) return null;

  const parentRoute = routes.find((r) => r.path === pathArray[0]);

  const getUrl = (index) => {
    if (index >= pathArray.length - 1) return "";
    const targetPath = pathArray.slice(0, index + 1).join("/");
    return findRouteUrl(parentRoute, targetPath);
  };

  return (
    <div>
      {pathArray.map((item, index) => {
        if (!item) return null;
        const pathName = getPathName(item);
        const url = getUrl(index);
        const isNonLink = nonLink?.includes(item);
        const separator = pathNames[item] === undefined
          ? " - "
          : (pathNames[item]?.length === 0 ? "" : " > ");

        return (
          <h3 className="breadCrumb" key={index}>
            {url && !isNonLink ? (
              <a className="breadCrumbItem" onClick={() => navigate(url)}>{pathName}</a>
            ) : (
              <span>{pathName}</span>
            )}
            {index < pathArray.length - 1 && separator && (
              <span>{separator}</span>
            )}
          </h3>
        );
      })}
    </div>
  );
};

BreadCrumb.propTypes = {
  path: PropTypes.string.isRequired,
  nonLink: PropTypes.arrayOf(PropTypes.string)
};

export default BreadCrumb;
